import { render, staticRenderFns } from "./IClose.vue?vue&type=template&id=21a9b85c&"
import script from "./IClose.vue?vue&type=script&lang=ts&"
export * from "./IClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports